import { DatePicker, Space, Select, Table, message, Spin, Form, Image, Tooltip, Button } from 'antd';
import dayjs from 'dayjs';
import {FileExcelOutlined } from '@ant-design/icons';
import constants from '../../constants/constants';
import { useContext, useEffect, useState } from 'react';
import WebLinks from '../../api/WebLinks';
import Cookies from 'js-cookie';
import APIUtils from '../../api/APIUtils';
import { downloadFiles } from '../../globalFunctions/GlobalFunctions';
import { CommonContext } from '../../Context';
const { RangePicker } = DatePicker;
const { Option } = Select

const LocationReport = (props) => {

	const expandedTableColumns = [
		{
			title: 'Occupation',
			dataIndex: 'occupation',
			key: 'occupation',
			align: 'center'
		},
		{
			title: 'Applies',
			dataIndex: 'totalApps',
			key: 'totalApps',
			align: 'center'
		},
		{
			title: 'Cost',
			dataIndex: 'cost',
			key: 'cost',
			align: 'center'
		},
		{
			title: 'Cost/Applies',
			dataIndex: 'costApply',
			key: 'costApply',
			align: 'center'
		},
		{
			title: 'Quality',
			dataIndex: 'qualityApps',
			key: 'qualityApps',
			align: 'center',
			sorter: (a, b) => a.qualityApps - b.qualityApps,
			render: (_, record) => {
				return (
					<>
						<span>{record.qualityApps + " "}</span><span>({record.qualityPer}%)</span>
					</>
				)
			}
		},
		{
			title: 'Cost/Quality',
			dataIndex: 'costQuality',
			key: 'costQuality',
			align: 'center',
			sorter: (a, b) => a.costQuality - b.costQuality,
		},
		{
			title: 'Interviews',
			dataIndex: 'interview',
			key: 'interview',
			align: 'center',
			sorter: (a, b) => a.interview - b.interview,
			render: (_, record) => {
				return (
					<>
						<span>{record.interview + " "}</span><span>({record.interviewPer}%)</span>
					</>
				)
			}
		},
		{
			title: 'Cost/Interview',
			dataIndex: 'costInterview',
			key: 'costInterview',
			align: 'center',
			sorter: (a, b) => a.costInterview - b.costInterview,
		},
		{
			title: 'Hires',
			dataIndex: 'hired',
			key: 'hired',
			align: 'center',
			sorter: (a, b) => a.hired - b.hired,
			render: (_, record) => {
				return (
					<Space size={3}>
						<span>{record.hired + " "}</span><span>({record.hiredPer}%)</span>
					</Space>
				)
			}
		},
		{
			title: 'Cost/Hire',
			dataIndex: 'costHire',
			key: 'costHire',
			align: 'center',
			sorter: (a, b) => a.costHire - b.costHire,
		}
	];
	const columns = [
		{
			title: 'City',
			dataIndex: 'city',
			key: 'city',
			sorter: (a, b) => a.city.localeCompare(b.city),
			render:(_,record)=>{
        return(<><span>{record.city}</span></>)
			}	
		},
		{
			title: 'Applies',
			dataIndex: 'totalApps',
			key: 'totalApps',
			align:'center',
			sorter:(a, b) => a.totalApps - b.totalApps,
		},
		{
			title: 'Cost',
			dataIndex: 'cost',
			key: 'cost',
			align:'center',
			sorter:(a, b) => a.cost - b.cost,
		},
		{
			title: 'Cost/Apply',
			dataIndex: 'costApply',
			key: 'costApply',
			align:'center',
			sorter:(a, b) => a.costApply - b.costApply,
		},
		{
			title: 'Quality',
			dataIndex: 'qualityApps',
			key: 'qualityApps',
			align:'center',
			sorter:(a, b) => a.qualityApps - b.qualityApps,
			render:(_,record)=>{
        return(
					<Space size={3}>
						<span>{record.qualityApps+" "}</span><span>({record.qualityPer}%)</span>
					</Space>
				)
			}
		},
		{
			title: 'Cost/Quality',
			dataIndex: 'costQuality',
			key: 'costQuality',
			align:'center',
			sorter:(a, b) => a.costQuality - b.costQuality,
		},
		{
			title: 'Interviews',
			dataIndex: 'interview',
			key: 'interview',
			align:'center',
			sorter:(a, b) => a.interview - b.interview,
			render:(_,record)=>{
        return(
					<><span>{record.interview+" " }</span><span>({record.interviewPer}%)</span></>
				)
			}
		},
		{
			title: 'Cost/Interview',
			dataIndex: 'costInterview',
			key: 'costInterview',
			align:'center',
			sorter:(a, b) => a.costInterview - b.costInterview,
		},
		{
			title: 'Hires',
			dataIndex: 'hired',
			key: 'hired',
			align:'center',
			sorter:(a, b) => a.hired - b.hired,
			render:(_,record)=>{
        return(
					<Space size={3}>
						<span>{record.hired+" "}</span><span>({record.hiredPer}%)</span>
					</Space>
				)
				
			}
		},
		{
			title: 'Cost/Hire',
			dataIndex: 'costHire',
			key: 'costHire',
			align:'center',
			sorter:(a, b) => a.costHire - b.costHire,
		}
	];
	const [monthlyData,setMonthlyData]=useState([]);
	const [occupationMonthlyData,setOccupationMonthlyData]=useState([]);
	const [currentPage,setCurrentPage]= useState(1);
	const [pageSize,setPageSize]=useState(25);
	const [rangePickerValue,setRangePickerValue]= useState([]);
	const [loader,setLoader]=useState(false);
	const [occupationLoader,setOccupationLoader]=useState(false);
	const [totalMonthCount,setTotalMonthCount]=useState(0);
	const [monthReportTotal, setMonthReportTotal] = useState([]);
	const [occupations, setOccupations] = useState([]);
	const [selectedOccupations, setSelectedOccupations] = useState(['allOccupation']);
	const [suplierListLoader,setSuplierListLoader]= useState(false);
	const [allowedSupplierList, setAllowedSupplierList] = useState([]);
  const [selectedSupplierIds,setSelectedsupplierIds]=useState([]);	
	const [form] = Form.useForm();
	const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;

	useEffect(()=>{
		form.resetFields();
		if(props&&props.dateSelectedValue){
		form.setFieldsValue({
			rangePicker:[dayjs(props.dateSelectedValue[0]),dayjs(props.dateSelectedValue[1])],
		})
		}else{
			form.setFieldsValue({
				rangePicker:[dayjs(),dayjs()],
			})
		}
		setCurrentPage(1);
		setPageSize(25);
		getAllowedSuppliers();
		setRangePickerValue(props&&props.dateSelectedValue?[dayjs(props.dateSelectedValue[0]).format(constants.MonthFormat),dayjs(props.dateSelectedValue[1]).format(constants.MonthFormat)]:[dayjs().format(constants.MonthFormat),dayjs().format(constants.MonthFormat)]);
		GetMonthlyLocationReport(1,25,props&&props.dateSelectedValue?dayjs(props.dateSelectedValue[0]).format(constants.MonthFormat):dayjs().format(constants.MonthFormat),props&&props.dateSelectedValue?dayjs(props.dateSelectedValue[1]).format(constants.MonthFormat):dayjs().format(constants.MonthFormat));
		getOccupationsList(props&&props.dateSelectedValue?dayjs(props.dateSelectedValue[0]).format(constants.MonthFormat):dayjs().format(constants.MonthFormat),props&&props.dateSelectedValue?dayjs(props.dateSelectedValue[1]).format(constants.MonthFormat):dayjs().format(constants.MonthFormat));
	},[props]);

	//Functions
	//Function gets occupation list from API
	const getOccupationsList = async (startDate,endDate)=>{
		setOccupationLoader(true);
		const response = await APIUtils.apiCall('GET',WebLinks.GetOccupations+buyerId+"&fromDate="+startDate+"&toDate="+endDate);
		const defaultItem ={value: 'allOccupation',label: 'Show All'};
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			let occupationList=response.resultObj.data?.map((item,index)=>({key:index, value:item.id, label:item.occupation+" ("+item.occupationCount+")"}))
			setOccupations([{...defaultItem}, ...occupationList] || [{...defaultItem}]);
		}else{
			setOccupations([...defaultItem]);
			message.error(response.resultObj.message);
		}
		setOccupationLoader(false);
	};
	const occupationsToString = (e) =>{
				
		let newList=e;
		let selectedOccList=e?.filter((item)=>item==="allOccupation");
		if(e?.length==0){
			form.setFieldsValue({occupations:['allOccupation']})
		}
		if(e?.length==1 && selectedOccList.length>0){
			newList=[];
		}
		
		if(e?.length>1){
			if(selectedOccList?.length>0){newList=e?.filter((item)=>item!=="allOccupation");}
			// setSelectedOccupations(newList);
			form.setFieldsValue({occupations:newList})
		}
		return newList || [];
	}
	//Function runs when range picker value is changed
	const RangePickerChanged= (_,dateString) => {
		//props.changeDate(dateString);
		setRangePickerValue(dateString);
		GetMonthlyLocationReport(currentPage,pageSize,dateString[0],dateString[1],occupationsToString(selectedOccupations),selectedSupplierIds);
		getOccupationsList(props && props.dateSelectedValue ? dayjs(props.dateSelectedValue[0]).format(constants.MonthFormat) : dayjs().format(constants.MonthFormat), props && props.dateSelectedValue ? dayjs(props.dateSelectedValue[1]).format(constants.MonthFormat) : dayjs().format(constants.MonthFormat));

	};

	//Function to get Allowed suppliers list
	const getAllowedSuppliers =async()=>{
		setSuplierListLoader(true);
		const response = await APIUtils.apiCall('GET',WebLinks.GetALlAllowedSuppliers);
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			setAllowedSupplierList(response?.resultObj?.data||[])
			setSuplierListLoader(false);
		}else{
			setAllowedSupplierList([]);
			setSuplierListLoader(false);
			message.error(response.resultObj.message);
		}
	}

	//Function on change of supplier selection
	const handleSupplierSelect=(selectedSuppliers)=>{
		if(selectedSuppliers.length>0){
			let tempSelectedSuppliers=selectedSuppliers.filter(value => value !== 'showall');
			let selectedSuppliersFinal=tempSelectedSuppliers.length>0?tempSelectedSuppliers:"";
			form.setFieldsValue({
				supplierList:selectedSuppliersFinal
			})
			setSelectedsupplierIds(selectedSuppliersFinal);
			GetMonthlyLocationReport(currentPage,pageSize,rangePickerValue[0],rangePickerValue[1],occupationsToString(selectedOccupations),selectedSuppliersFinal);

		}else{
			form.setFieldsValue({
				supplierList:["showall"]
			})
			setSelectedsupplierIds([]);
	      GetMonthlyLocationReport(currentPage,pageSize,rangePickerValue[0],rangePickerValue[1],occupationsToString(selectedOccupations),null);
		}
	}

	const downloadFile = async () => {
		setLoader(true);
		try {
			let selectedOccList = occupationsToString(form.getFieldValue("occupations"));
			const formattedStartDate = dayjs(rangePickerValue[0],constants.MonthFormat)
				.startOf("month").format("YYYY-MM-DD");

			const formattedEndDate = dayjs(rangePickerValue[1],constants.MonthFormat)
				.endOf("month").format("YYYY-MM-DD");
			let apiurl =WebLinks.DownloadLocationReportExcel +buyerId +`&fromDate=${formattedStartDate}&toDate=${formattedEndDate}`;
			if (selectedOccList?.length > 0) {
				selectedOccList = selectedOccList.filter(
					(item) => item !== "allOccupation"
				);
				const occupationIDS = selectedOccList.join(",");
				apiurl += `&occupationId=${occupationIDS}`;
			}
			if (selectedSupplierIds?.length > 0) {
				apiurl += `&selectedSupplierId=${selectedSupplierIds}`;
			}
			await downloadFiles(apiurl, "LocationReport.xlsx");
		} catch (error) {
			console.error("Download error:", error);
		} finally {
			setLoader(false);
		}
	};

	//Function to Month location report data
	const GetMonthlyLocationReport = async (
		currentPage,
		pazeSize,
		startDate,
		endDate,
		selectedOccList = [],
		supplierId = null
	) => {
		setLoader(true);
		selectedOccList = occupationsToString(form.getFieldValue("occupations"));
		let apiurl = WebLinks.GetMonthlyLocationReport + buyerId;
		let occupationIDS = "";
		if (selectedOccList?.length > 0) {
			selectedOccList = selectedOccList.filter((item) => item !== "allOccupation");
			occupationIDS = selectedOccList.join(",");
		}
		const formattedStartDate = dayjs(startDate, constants.MonthFormat).startOf("month").format("YYYY-MM-DD");
		const formattedEndDate = dayjs(endDate, constants.MonthFormat).endOf("month").format("YYYY-MM-DD");
		let url = apiurl + "&fromDate=" + formattedStartDate + "&toDate=" + formattedEndDate + "&occupationId=" + occupationIDS + "&limit=" + pazeSize + "&pageNo=" + currentPage;
		if (supplierId && supplierId.length > 0) {
			url += "&selectedSupplierId=" + supplierId;
		}
		const response = await APIUtils.apiCall('GET', url);
		if (!response.isCatch && response.resultObj.statusCode === "2000") {
			let dataResponse, count;
			dataResponse = response.resultObj.data;
			count = response.resultObj.getCount;
			const totalRecord = dataResponse?.pop() || [];
			dataResponse = dataResponse?.map((item, index) => ({
				...item,
				index: index
			}));
			setMonthReportTotal(totalRecord);
			setMonthlyData(dataResponse);
			setTotalMonthCount(count);
			setLoader(false);
		} else {
			setMonthlyData([]);
			setMonthReportTotal({});
			setLoader(false);

			message.error(
				response?.resultObj?.message || constants.ERROR_MESSAGE
			);
		}
	};
	//Function on change of application table
	const onchangeApplicationTable = (pagination, filters, sorter) =>{
		if(pagination){
			if(pageSize!==pagination.pageSize){
				setCurrentPage(1);
			}else{
				setCurrentPage(pagination?.current);
			}
			setPageSize(pagination?.pageSize);
			GetMonthlyLocationReport(pagination?.current,pagination?.pageSize,rangePickerValue[0],rangePickerValue[1],occupationsToString(selectedOccupations),selectedSupplierIds)
		}
	};

	//Funcion to render inner table
	const getInnerTable = (tableData) => {
		return (
			<Table
				bordered
				size="small"
				columns={expandedTableColumns}
				dataSource={tableData}
				pagination={false}
				// pagination={{
				// 	defaultPageSize: 100,
				// 	pageSizeOptions: ["100", "250", "500"],
				// }}
			/>
		)
	}
	
	//Function to display the month total in the table
	const monthReportSummary = () => {
		return (
			<Table.Summary.Row className="bg-teal-50">
				<Table.Summary.Cell index={0} className="text-center">
				</Table.Summary.Cell>

				<Table.Summary.Cell index={1} align="center">
					<strong>Totals</strong>
				</Table.Summary.Cell>

				<Table.Summary.Cell index={2} className="text-center">
					<strong>{monthReportTotal?.totalApps}</strong>
				</Table.Summary.Cell>

				<Table.Summary.Cell index={3} className="text-center">
					<strong>{monthReportTotal?.cost}</strong>
				</Table.Summary.Cell>

				<Table.Summary.Cell index={4} className="text-center">
					<strong>{monthReportTotal?.costApply}</strong>
				</Table.Summary.Cell>

				<Table.Summary.Cell index={5} className="text-center">
					<strong>
						<Space size={3}>
							{monthReportTotal?.qualityApps}
							<span>
								({monthReportTotal?.qualityPer}%)
							</span>
						</Space>
					</strong>
				</Table.Summary.Cell>

				<Table.Summary.Cell index={6} className="text-center">
					<strong>{monthReportTotal?.costQuality}</strong>
				</Table.Summary.Cell>

				<Table.Summary.Cell index={7} className="text-center">
					<strong>
						<Space size={3}>
							{monthReportTotal?.interview}
							<span>
								({monthReportTotal?.interviewPer}%)
							</span>
						</Space>
					</strong>
				</Table.Summary.Cell>

				<Table.Summary.Cell index={8} className="text-center">
					<strong>{monthReportTotal?.costInterview}</strong>
				</Table.Summary.Cell>

				<Table.Summary.Cell index={9} className="text-center">
					<strong>
						<Space size={3}>
							{monthReportTotal?.hired}
							<span>
								({monthReportTotal?.hiredPer}%)
							</span>
						</Space>
					</strong>
				</Table.Summary.Cell>

				<Table.Summary.Cell index={10} className="text-center">
					<strong>{monthReportTotal?.costHire}</strong>
				</Table.Summary.Cell>
			</Table.Summary.Row>
		);
	};

	return (
		<>
		<Spin spinning={loader}>
			<div>
				<Form form={form} className='!w-full flex flex-wrap gap-3 justify-between items-center mb-3'>
					<Space wrap>
						<Form.Item name="rangePicker" className='mb-0'>
						<RangePicker picker="month" placeholder={["From", "To"]} onChange={RangePickerChanged} format={constants.MonthFormat} />
						</Form.Item>
						<label className='ml-2 mr-2'>Filter by Supplier</label>
					<Form.Item name="supplierList" className='mb-0'>
						<Select
							loading={suplierListLoader}
							className='!w-60'
							// value={selectedSupplier || []}
							placeholder={constants.supplierName}
							mode='multiple'
							allowClear
							defaultValue={"showall"}
							showSearch
              filterOption={(input, option) =>
                  option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
                onChange={(e) => handleSupplierSelect(e)}
							>
								<Option key='showall' value='showall'>Show all</Option>
									{allowedSupplierList?.map((supplier) => (
										<Option key={supplier.supplierId}
												value={supplier.supplierId}
										>
										{supplier.name}</Option>
							))}
						</Select>
					</Form.Item>
					</Space>
					<Space wrap>
						<label>Filter by Occupation</label>
							<Form.Item name="occupations" initialValue={["allOccupation"]} className='mb-0' >
								<Select
									className='!w-72'
									mode="multiple"
									allowClear
									maxTagCount='responsive'
									options={occupations}
									loading={occupationLoader}
									// value={selectedOccupations}
									onChange={(e)=>{
										setSelectedOccupations(e);
										GetMonthlyLocationReport(currentPage,pageSize,rangePickerValue[0],rangePickerValue[1],occupationsToString(e),selectedSupplierIds);
									}}
									optionFilterProp="label"
									filterSort={(optionA, optionB) =>
									  (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
									}
								/>
							</Form.Item>
							<Tooltip placement='right' title="Download as Excel">
								<Button
										className='bg-green-800 text-white hover:!text-white hover:!border-green-500'
										icon={<FileExcelOutlined />}
										onClick={()=>{downloadFile()}}
								>
									Download as Excel
								</Button>
							</Tooltip>
					</Space>
				</Form>
				<div className='overflow-x-auto'>
					<Table
						columns={columns}
						dataSource={monthlyData}
						scroll={{
							x: 1000,
						}}
						sortDirections={['descend','ascend']}
						// onChange ={onchangeApplicationTable}
						expandable={{
							expandedRowRender: (record) => (<div>
								{getInnerTable(record.monthlyLocationOccupationReports)}
							</div>)
						}}
						rowKey="index"
						pagination={false}
						summary={() => monthReportSummary()}
					/>
				</div>
			</div>
		</Spin>
		</>
	);
};
export default LocationReport;
